/**
 * Admin API service for login provider + feature binding management
 */

import { api } from '@services/api';
import { API_PATHS } from '@utils/constants';
import {
  ProviderListSchema,
  ProviderSchema,
  BindingListSchema,
  BindingSchema,
  TestConnectionSchema,
  type Provider,
  type Binding,
  type TestConnection,
  type ProviderRequestBody,
} from '../types';

export const adminLoginsApi = {
  listProviders: async (): Promise<Provider[]> => {
    const response = await api.get(`${API_PATHS.ADMIN_LOGINS}/providers`);
    const data: unknown = response.data;
    return ProviderListSchema.parse(data);
  },

  createProvider: async (body: ProviderRequestBody): Promise<Provider> => {
    const response = await api.post(`${API_PATHS.ADMIN_LOGINS}/providers`, body);
    const data: unknown = response.data;
    return ProviderSchema.parse(data);
  },

  updateProvider: async (id: string, body: ProviderRequestBody): Promise<Provider> => {
    const response = await api.put(`${API_PATHS.ADMIN_LOGINS}/providers/${id}`, body);
    const data: unknown = response.data;
    return ProviderSchema.parse(data);
  },

  deleteProvider: async (id: string): Promise<void> => {
    await api.delete(`${API_PATHS.ADMIN_LOGINS}/providers/${id}`);
  },

  listBindings: async (providerId: string): Promise<Binding[]> => {
    const response = await api.get(
      `${API_PATHS.ADMIN_LOGINS}/providers/${providerId}/bindings`,
    );
    const data: unknown = response.data;
    return BindingListSchema.parse(data);
  },

  createBinding: async (providerId: string, featureId: string): Promise<Binding> => {
    const response = await api.post(
      `${API_PATHS.ADMIN_LOGINS}/providers/${providerId}/bindings`,
      { feature_id: featureId },
    );
    const data: unknown = response.data;
    return BindingSchema.parse(data);
  },

  deleteBinding: async (providerId: string, bindingId: string): Promise<void> => {
    await api.delete(
      `${API_PATHS.ADMIN_LOGINS}/providers/${providerId}/bindings/${bindingId}`,
    );
  },

  testProvider: async (providerId: string): Promise<TestConnection> => {
    const response = await api.post(
      `${API_PATHS.ADMIN_LOGINS}/providers/${providerId}/test`,
    );
    const data: unknown = response.data;
    return TestConnectionSchema.parse(data);
  },
};
